import { EntityPropList } from '@/common/entities/entityProp/EntityPropList';
import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityTabs } from '@/common/entityFramework/entityTabs/EntityTabs';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { ValList } from '@/common/val/ValList';
import { useCtrtOutline } from '@/md/entities/ctrt/useCtrtOutline';
import { PriceResList } from '@/md/entities/priceRes/PriceResList';
import { ProgContextStrip } from '@/md/entities/prog/ProgContextStrip';
import { ProgForm } from '@/md/entities/prog/ProgForm';
import { Box } from '@mui/material';
import { ProgProdCardList } from '../progProd/ProgProdCardList';

// Contract + Program context strip on top; Products (with their Tiers) as cards in their own tab so nothing below
// the Program requires navigating away
export const ProgDetail = () => {
  const { entityObj } = useEntityMgr();

  const canEdit = entityObj.status === 'DRAFT';
  const isPayment = entityObj.progType === 'PERF' || entityObj.progType === 'GROWTH';

  const { augButtons, outlineContent } = useCtrtOutline({
    ctrtId: entityObj.ctrtId,
    entity: 'PROG',
    entityId: entityObj.id,
  });

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <ProgForm /> },
    {
      id: 'progProd',
      label: 'Products',
      content: (
        <Box sx={{ flex: 1, minHeight: 0, overflow: 'auto', pb: 2 }}>
          <ProgProdCardList
            progObj={entityObj}
            canEdit={canEdit}
            basisLabel={isPayment ? 'Payment Basis' : 'Basis'}
            showPricing={!entityObj.tierBased}
          />
        </Box>
      ),
    },
  ];

  if (entityObj.status === 'IMPL') {
    tabSpecs.push({
      id: 'priceRes',
      label: entityObj.progType === 'PRICE' ? 'Price Results' : 'Rebate Results',
      content: <PriceResList progObj={entityObj} />,
    });
  }

  tabSpecs.push(
    // { id: 'cotFilter', label: 'Class of Trade Filters', content: <ProgCotFilterList progObj={entityObj} /> },
    {
      id: 'entityProps',
      label: 'Properties',
      content: <EntityPropList parentEntity="PROG" parentEntityObj={entityObj} />,
    },
    { id: 'val', label: 'Validations', content: <ValList parentEntity="PROG" parentEntityId={entityObj.id} /> },
  );

  return (
    <EntityDetail tabSpecs={tabSpecs} augButtons={augButtons}>
      {outlineContent ?? (
        <>
          <ProgContextStrip ctrtId={entityObj.ctrtId} />
          <EntityTabs tabSpecs={tabSpecs} />
        </>
      )}
    </EntityDetail>
  );
};
